import {createAsyncThunk} from '@reduxjs/toolkit'

import {getMembershipPromotionJoin} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

const navigateToMembershipJoin = createAsyncThunk<
    NavigationResult,
    NavigationTypeSelectableParam & {isAgree: boolean},
    ThunkApi
>('navigateTo/membershipJoin', async ({forceLocationChange = false, isAgree}) => {
    const url = getMembershipPromotionJoin({isAgree})
    if (forceLocationChange) {
        changeBrowserLocation({
            url,
            type: 'PUSH',
        })
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    }

    openNewTab({url})
})

export default navigateToMembershipJoin
